import StatusBadge from "../../generals/StatusBadge";

function formatValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

function DetailRow({ label, value }) {
  return (
    <div className="mt-2 flex flex-row items-start text-gray-700">
      <div className="w-[140px] flex-shrink-0 text-sm mr-2">{label}</div>
      <div className="text-xs font-bold break-words">{formatValue(value)}</div>
    </div>
  );
}

function SubDepartmentOverview({ subDepartment }) {
  if (!subDepartment) return null;

  return (
    <div className="border-[1px] border-gray-200 rounded-lg p-4 @container">
      <div className="w-full @xl:grid @xl:grid-cols-5 @xl:gap-4">
        <div className="mt-3 @xl:col-span-3">
          <div className="text-gray-600 font-bold text-xl">
            {subDepartment.name}
          </div>
          <DetailRow label="Id" value={subDepartment.id} />
          <DetailRow label="Name" value={subDepartment.name} />
          <DetailRow label="Department" value={subDepartment.departmentName} />
          <div className="mt-2 flex flex-row items-center text-gray-700">
            <div className="w-[140px] flex-shrink-0 text-sm mr-2">Status</div>
            <StatusBadge
              statusId={subDepartment.statusId}
              statusName={subDepartment.statusName}
            />
          </div>
          <DetailRow label="Created By" value={subDepartment.createdBy} />
          <DetailRow label="Created At" value={subDepartment.createdAt} />
          <DetailRow label="Last Changed By" value={subDepartment.lastChangedBy} />
          <DetailRow label="Last Changed At" value={subDepartment.lastChangedAt} />
        </div>
      </div>
    </div>
  );
}

export default SubDepartmentOverview;
